import { Box, Button, Container, Flex, Heading, Text } from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';
import HYBRID_POSTERS_IMAGE from '@/assets/images/presentation/hybrid-posters.png';

export const HybridPosters = () => {
  const { t } = useTranslation();

  return (
    <Box bgColor="gray.900" py={14} mt={14} textAlign="center">
      <Container mx="auto">
        <Flex color="white" flexDirection="column" alignItems="center" maxW="800px" margin="auto">
          <Heading mb={8} fontSize="3xl">
            {t('hybridEventsPage.hybridPostersTitle')}
          </Heading>
          <Image src={HYBRID_POSTERS_IMAGE} alt="hybrid poster" />
          <Text mt={12} fontSize="3xl">
            {t('hybridEventsPage.hybridPostersTitle2.0')}
          </Text>
          <Heading as="span" fontSize="3xl" fontWeight="bold">
            {t('hybridEventsPage.hybridPostersTitle2.1')}
          </Heading>
          <Text mt={6}>{t('hybridEventsPage.hybridPostersDescription')}</Text>
          <Button
            as={Link}
            href="/contact-us/conferences"
            variant="solid"
            alignSelf="center"
            mt={6}
            rightIcon={<ArrowIcon />}
          >
            {t('newEventPage.getStarted')}
          </Button>
        </Flex>
      </Container>
    </Box>
  );
};
